"use strict";

angular.module("customer")
.component("carousel", {
    templateUrl: require("./carousel.component.html"),
    controller: CarouselController,
    controllerAs: "carouselCtrl",
    bindings: {
        hasInstances: "=?",
        service: "<"
    }
});

function CarouselController($scope, $timeout, $element, Language) {
    var _this = this;
    Language.initializeScope($scope, null, "locale");

    $scope.pagination = {};
    $scope.buttonEnabled = true;
    $scope.buttonPreviousDisplayed = false;
    $scope.buttonNextDisplayed = false;

    var slickElement = $element.find(".slick");
    var responsiveSettings = [{
        breakpoint: 1200,
        settings: {
            slidesToShow: 5,
            slidesToScroll: 5
        }
    }, {
        breakpoint: 996,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 4
        }
    }, {
        breakpoint: 768,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3
        }
    }, {
        breakpoint: 560,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }];
    var slickSettings = {
        arrows: false,
        responsive: responsiveSettings,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        initialSlide: 0
    };

    slickElement.slick(slickSettings);
    var slick = slickElement[0].slick;

    slickElement.on("setPosition", function(event, slick) {
        $timeout(updateArrows);
    });

    slickElement.on("swipe", function(event, slick, direction) {
        $timeout(preloadSlides);
    });

    this.previousSlide = function() {
        slick.slickPrev();
        preloadSlides();
    };

    this.nextSlide = function() {
        slick.slickNext();
        preloadSlides();
    };

    function fetch() {
        $scope.buttonEnabled = false;

        return _this.service.query($scope.pagination.current_page).then(function(data) {
            $scope.pagination = data.pagination;
            _this.hasInstances = data.results.length;

            angular.forEach(data.results, function(value) {
                var scope = $scope.$new();
                slick.slickAdd(_this.service.compile(scope, value, slick));
            });

            preloadSlides();
        }).finally(function() {
            $scope.buttonEnabled = true;
        });
    }

    function preloadSlides() {
        var lastSlideVisible = slick.slickCurrentSlide() + slick.options.slidesToShow;
        var remainingHiddenSlidesCount = slick.slideCount - lastSlideVisible;
        var slidesBuffer = slick.options.slidesToScroll * 2;

        if (remainingHiddenSlidesCount <= slidesBuffer && slick.slideCount < $scope.pagination.count) {
            $scope.pagination.current_page++;
            fetch();
        }
    }

    function updateArrows() {
        var currentSlide = slick.slickCurrentSlide();
        $scope.buttonPreviousDisplayed = currentSlide > 0;

        var lastSlideVisible = currentSlide + slick.options.slidesToShow;
        $scope.buttonNextDisplayed = lastSlideVisible < $scope.pagination.count;
    }

    fetch();
}



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/carousel/carousel.component.js
// module id = 837
// module chunks = 0